const data = {
  title: "Floor 1-9",
  musicTrack: "MUSIC_WORLD1",
  theme: "BLUE",
  tilesWidth: 11,
  tilesHeight: 11,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 6,
      y: 6,
    },
    {
      type: "THIEF",
      x: 4,
      y: 6,
    },
    {
      type: "WALL",
      x: 4,
      y: 1,
    },
    {
      type: "WALL",
      x: 4,
      y: 3,
    },
    {
      type: "WALL",
      x: 1,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 4,
    },
    {
      type: "WALL",
      x: 8,
      y: 1,
    },
    {
      type: "WALL",
      x: 8,
      y: 3,
    },
    {
      type: "WALL",
      x: 8,
      y: 4,
    },
    {
      type: "WALL",
      x: 9,
      y: 4,
    },
    {
      type: "WALL",
      x: 11,
      y: 4,
    },
    {
      type: "WALL",
      x: 11,
      y: 8,
    },
    {
      type: "WALL",
      x: 9,
      y: 8,
    },
    {
      type: "WALL",
      x: 8,
      y: 8,
    },
    {
      type: "WALL",
      x: 8,
      y: 9,
    },
    {
      type: "WALL",
      x: 1,
      y: 8,
    },
    {
      type: "WALL",
      x: 3,
      y: 8,
    },
    {
      type: "WALL",
      x: 4,
      y: 8,
    },
    {
      type: "WALL",
      x: 4,
      y: 9,
    },
    {
      type: "WALL",
      x: 4,
      y: 11,
    },
    {
      type: "WALL",
      x: 7,
      y: 8,
    },
    {
      type: "WALL",
      x: 7,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 5,
    },
    {
      type: "WALL",
      x: 4,
      y: 7,
    },
    {
      type: "WALL",
      x: 8,
      y: 5,
    },
    {
      type: "WALL",
      x: 8,
      y: 7,
    },
    {
      type: "THIEF",
      x: 8,
      y: 6,
    },
    {
      type: "LOCK",
      x: 6,
      y: 4,
      color: "BLUE",
    },
    {
      type: "SWITCH",
      x: 6,
      y: 10,
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 8,
      isRaised: false,
    },
    {
      type: "CHIP",
      x: 10,
      y: 10,
    },
    {
      type: "KEY",
      x: 2,
      y: 10,
      color: "GREEN",
    },
    {
      type: "CHIP",
      x: 6,
      y: 2,
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 5,
      direction: "DOWN",
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 6,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 9,
      y: 10,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 7,
      direction: "UP",
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 6,
      direction: "RIGHT",
    },
    {
      type: "LOCK",
      x: 2,
      y: 4,
      color: "GREEN",
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 8,
      isRaised: true,
    },
    {
      type: "LOCK",
      x: 8,
      y: 10,
      color: "GREEN",
    },
    {
      type: "WALL",
      x: 3,
      y: 4,
    },
    {
      type: "WALL",
      x: 5,
      y: 4,
    },
    {
      type: "WALL",
      x: 8,
      y: 11,
    },
    {
      type: "WALL",
      x: 5,
      y: 8,
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 10,
      isRaised: false,
    },
    {
      type: "CONVEYOR",
      x: 3,
      y: 2,
      direction: "RIGHT",
    },
    {
      type: "SWITCH",
      x: 2,
      y: 6,
    },
    {
      type: "KEY",
      x: 10,
      y: 2,
      color: "BLUE",
    },
    {
      type: "CONVEYOR",
      x: 10,
      y: 7,
      direction: "DOWN",
    },
    {
      type: "LOCK",
      x: 10,
      y: 8,
      color: "GREEN",
    },
  ],
};

export default data;
